// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2f8e8240","732":"07f988cf","977":"49ff19d9"}[chunkId] + ".chunk.js";
};